import actions from "./actions";

const initialState = {
  error: null,
  total: 0,
  loading: false,
  saving: false,
  executing: false,
  cancelling: false,
  importing: false,
  items: [],
  detail: null,
  currentJob: null,
  histories: [],
};

export default function reviewCrawlingSettingReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SEARCH_REQUEST:
      return { ...state, loading: true };
    case actions.SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        total: action.total,
        items: action.items,
      };
    case actions.SEARCH_ERROR:
      return { ...state, loading: false, error: action.error };

    case actions.CREATE_REQUEST:
    case actions.UPDATE_REQUEST:
      return { ...state, saving: true };
    case actions.CREATE_SUCCESS:
    case actions.UPDATE_SUCCESS:
      return { ...state, saving: false };
    case actions.CREATE_ERROR:
    case actions.UPDATE_ERROR:
      return { ...state, saving: false, error: action.error };

    case actions.DETAIL_REQUEST:
      return { ...state, loading: true };
    case actions.DETAIL_SUCCESS:
      return { ...state, loading: false, detail: action.detail };
    case actions.DETAIL_ERROR:
      return { ...state, loading: false };

    case actions.DELETE_REQUEST:
      return { ...state, saving: true };
    case actions.DELETE_SUCCESS:
      return { ...state, saving: false };
    case actions.DELETE_ERROR:
      return { ...state, saving: false };

    case actions.EXECUTE_REQUEST:
      return { ...state, executing: true };
    case actions.EXECUTE_SUCCESS:
    case actions.EXECUTE_ERROR:
      return { ...state, executing: false };

    case actions.CANCEL_REQUEST:
      return { ...state, cancelling: true };
    case actions.CANCEL_SUCCESS:
    case actions.CANCEL_ERROR:
      return { ...state, cancelling: false };

    case actions.GET_CURRENT_SUCCESS:
      return { ...state, currentJob: action.currentJob };
    case actions.GET_CURRENT_ERROR:
      return { ...state, currentJob: null };

    case actions.GET_HISTORIES_SUCCESS:
      return {
        ...state,
        histories: Array.isArray(action.histories) ? action.histories : [],
      };
    case actions.GET_HISTORIES_ERROR:
      return { ...state, histories: [] };

    case actions.IMPORT_REQUEST:
      return { ...state, importing: true };
    case actions.IMPORT_SUCCESS:
    case actions.IMPORT_ERROR:
      return { ...state, importing: false };

    case actions.RESET_DETAIL:
      return {
        ...state,
        detail: null,
        currentJob: null,
        histories: [],
      };

    default:
      return state;
  }
}
